
function HostExperience() {
  return (
    <>
    <section className="ser_v_araeea allpages where_sh_gudes">
     <div className="container">
	   <div className="abt_pgs_areea boths">
	     <h2>Where should guests meet you ?</h2>
		 <p>Guests will see this address on your listing</p>
	   </div>	 
	   
	   <div className="form_al_fildss">
		 <form action="">
	      <div class="form-group manasess">
           <input type="text" id="" class="form-control" placeholder="" required=""/>
		   <button type="submit" className="src" value="submit"><i class="fa fa-search"></i></button>		   
          </div>
		 </form>
	   </div>
	 </div>
	</section> 
    </>
  )
}

export default HostExperience